__turbopack_context__.v({
  "actions": "homepage-proof-module__Son3xW__actions",
  "arrive": "homepage-proof-module__Son3xW__arrive",
  "avatarFallback": "homepage-proof-module__Son3xW__avatarFallback",
  "avatars": "homepage-proof-module__Son3xW__avatars",
  "bookGroup": "homepage-proof-module__Son3xW__bookGroup",
  "bookTrack": "homepage-proof-module__Son3xW__bookTrack",
  "bookWindow": "homepage-proof-module__Son3xW__bookWindow",
  "books": "homepage-proof-module__Son3xW__books",
  "cardTop": "homepage-proof-module__Son3xW__cardTop",
  "centerHeading": "homepage-proof-module__Son3xW__centerHeading",
  "dialogBody": "homepage-proof-module__Son3xW__dialogBody",
  "dialogHeader": "homepage-proof-module__Son3xW__dialogHeader",
  "drift": "homepage-proof-module__Son3xW__drift",
  "edgeResult": "homepage-proof-module__Son3xW__edgeResult",
  "exampleStats": "homepage-proof-module__Son3xW__exampleStats",
  "expand": "homepage-proof-module__Son3xW__expand",
  "faq": "homepage-proof-module__Son3xW__faq",
  "faqItem": "homepage-proof-module__Son3xW__faqItem",
  "finalCta": "homepage-proof-module__Son3xW__finalCta",
  "finalGlow": "homepage-proof-module__Son3xW__finalGlow",
  "finePrint": "homepage-proof-module__Son3xW__finePrint",
  "flipped": "homepage-proof-module__Son3xW__flipped",
  "float": "homepage-proof-module__Son3xW__float",
  "footer": "homepage-proof-module__Son3xW__footer",
  "footerBrand": "homepage-proof-module__Son3xW__footerBrand",
  "footerNote": "homepage-proof-module__Son3xW__footerNote",
  "header": "homepage-proof-module__Son3xW__header",
  "hero": "homepage-proof-module__Son3xW__hero",
  "heroCopy": "homepage-proof-module__Son3xW__heroCopy",
  "heroGlow": "homepage-proof-module__Son3xW__heroGlow",
  "heroProof": "homepage-proof-module__Son3xW__heroProof",
  "heroSocial": "homepage-proof-module__Son3xW__heroSocial",
  "how": "homepage-proof-module__Son3xW__how",
  "iconButton": "homepage-proof-module__Son3xW__iconButton",
  "imageDialog": "homepage-proof-module__Son3xW__imageDialog",
  "lede": "homepage-proof-module__Son3xW__lede",
  "login": "homepage-proof-module__Son3xW__login",
  "logo": "homepage-proof-module__Son3xW__logo",
  "market": "homepage-proof-module__Son3xW__market",
  "marquee": "homepage-proof-module__Son3xW__marquee",
  "menuButton": "homepage-proof-module__Son3xW__menuButton",
  "nav": "homepage-proof-module__Son3xW__nav",
  "navActions": "homepage-proof-module__Son3xW__navActions",
  "navLinks": "homepage-proof-module__Son3xW__navLinks",
  "orbits": "homepage-proof-module__Son3xW__orbits",
  "page": "homepage-proof-module__Son3xW__page",
  "plan": "homepage-proof-module__Son3xW__plan",
  "planGrid": "homepage-proof-module__Son3xW__planGrid",
  "planNote": "homepage-proof-module__Son3xW__planNote",
  "planPrice": "homepage-proof-module__Son3xW__planPrice",
  "planTop": "homepage-proof-module__Son3xW__planTop",
  "planTrial": "homepage-proof-module__Son3xW__planTrial",
  "priceCard": "homepage-proof-module__Son3xW__priceCard",
  "pricing": "homepage-proof-module__Son3xW__pricing",
  "pricingFoot": "homepage-proof-module__Son3xW__pricingFoot",
  "primary": "homepage-proof-module__Son3xW__primary",
  "productImage": "homepage-proof-module__Son3xW__productImage",
  "profitBadge": "homepage-proof-module__Son3xW__profitBadge",
  "profitLabel": "homepage-proof-module__Son3xW__profitLabel",
  "proof-fly-in": "homepage-proof-module__Son3xW__proof-fly-in",
  "proofButton": "homepage-proof-module__Son3xW__proofButton",
  "proofCaption": "homepage-proof-module__Son3xW__proofCaption",
  "proofFlyIn": "homepage-proof-module__Son3xW__proofFlyIn",
  "proofImage": "homepage-proof-module__Son3xW__proofImage",
  "proofPause": "homepage-proof-module__Son3xW__proofPause",
  "proofStage": "homepage-proof-module__Son3xW__proofStage",
  "proofWaiting": "homepage-proof-module__Son3xW__proofWaiting",
  "quote": "homepage-proof-module__Son3xW__quote",
  "quotes": "homepage-proof-module__Son3xW__quotes",
  "recentReviews": "homepage-proof-module__Son3xW__recentReviews",
  "reveal": "homepage-proof-module__Son3xW__reveal",
  "reviewAuthor": "homepage-proof-module__Son3xW__reviewAuthor",
  "reviewCard": "homepage-proof-module__Son3xW__reviewCard",
  "reviewGrid": "homepage-proof-module__Son3xW__reviewGrid",
  "reviewHeading": "homepage-proof-module__Son3xW__reviewHeading",
  "reviewReceipt": "homepage-proof-module__Son3xW__reviewReceipt",
  "reviewSource": "homepage-proof-module__Son3xW__reviewSource",
  "reviews": "homepage-proof-module__Son3xW__reviews",
  "screenCaption": "homepage-proof-module__Son3xW__screenCaption",
  "screenChrome": "homepage-proof-module__Son3xW__screenChrome",
  "secondary": "homepage-proof-module__Son3xW__secondary",
  "section": "homepage-proof-module__Son3xW__section",
  "sectionCopy": "homepage-proof-module__Son3xW__sectionCopy",
  "steps": "homepage-proof-module__Son3xW__steps",
  "textLink": "homepage-proof-module__Son3xW__textLink",
  "toolDescription": "homepage-proof-module__Son3xW__toolDescription",
  "toolPanel": "homepage-proof-module__Son3xW__toolPanel",
  "toolTabs": "homepage-proof-module__Son3xW__toolTabs",
  "tools": "homepage-proof-module__Son3xW__tools",
  "trialTerms": "homepage-proof-module__Son3xW__trialTerms",
  "xMark": "homepage-proof-module__Son3xW__xMark",
});
